import React, { Suspense } from "react";
import { BrowserRouter, Route } from "react-router-dom";
import { ShoppingCartProvider } from "./hooks/shoppingcart";
import { I18nextProvider } from 'react-i18next';
import { createMuiTheme, ThemeProvider } from "@material-ui/core/styles";
import CssBaseline from "@material-ui/core/CssBaseline";
import PriceListProvider from "../Providers/PriceListProvider";
import { AuthProvider } from "./hooks/auth";
import ScrollToTop from "../Common/ScrollToTop";

// This have to be ran here:
import { Switch } from "react-router";
import LoaderInterwind from "../Common/LoaderInterwind";
import useMobileRoutes from "./hooks/useMobileRoutes";
import i18n from "../../i18n";

const theme = createMuiTheme(window.THEME);

class DebugRouter extends BrowserRouter {
  constructor(props) {
    super(props);
    console.log("initial history is: ", JSON.stringify(this.history, null, 2));
    console.log(this);
    this.history.listen((location, action) => {
      console.log(
        `The current URL is ${location.pathname}${location.search}${location.hash}`
      );
      console.log(`The last navigation action was ${action}`, this);
    });
  }
}

const Router = () => {
  const mobileRoutes = useMobileRoutes();
  return (
    <ThemeProvider theme={theme}>
      <Suspense fallback={<MainLoader />}>
        <I18nextProvider i18n={i18n}>
          <PriceListProvider>
            <ShoppingCartProvider>
              <AuthProvider>
                <CssBaseline />
                <DebugRouter basename={`/m`}>
                  <ScrollToTop />
                  <Switch>
                    {Object.keys(mobileRoutes).map((key) => {
                      const route = mobileRoutes[key];
                      console.log('Route path', route.path);
                      return (
                        <Route
                          key={key}
                          exact={typeof route.exact == "undefined" ? true : route.exact}
                          path={route.path}
                          component={route.component}
                        />
                      );
                    })}
                  </Switch>
                </DebugRouter>
              </AuthProvider>
            </ShoppingCartProvider>
          </PriceListProvider>
        </I18nextProvider>
      </Suspense>
    </ThemeProvider>
  );
};

export default Router;

const MainLoader = () => {
  return <LoaderInterwind />;
};
